(ns manage.slate-editor.mentions-node
  (:require ["@mui/material/Typography$default" :as Typography]
            [cljs-bean.core :refer [->clj]]
            [common.queries :refer [use-query]]
            [common.resource.query.user :as user-queries]
            [common.util :refer [spread-obj]]
            [uix.core :refer [$ defui] :as uix]
            [uix.re-frame :refer [use-subscribe]]))

(defui mention [{:keys [children user-id]}]
  (let [{:keys [agency-id]} (use-subscribe [:url-context])
        user-id->user-select (uix/use-callback (fn [data]
                                                 (some #(when (= (:id %) user-id)
                                                          (select-keys % [:id :name :email]))
                                                       (->clj data)))
                                               [user-id])
        {{:keys [name]} :data} (use-query (spread-obj (user-queries/users-query {:agency-id agency-id})
                                                      #js {:select user-id->user-select}))]
    ($ Typography {:component "span"
                   :contentEditable false
                   :sx #js {:color "text.selected"}}
       name
       children)))

